import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import WelcomePage from "./pages/WelcomePage";
import ModulePage from "./pages/ModulePage";
import Sidebar from "./components/Sidebar";
import FreeTier from "./free/FreeTier";
import AdminWaitlist from "./free/AdminWaitlist";
import PublicCalculator from "./free/PublicCalculator";
import PaidGate from "./paid/PaidGate";
import LegalPage from "./legal/LegalPage";
import ConsentBanner from "./legal/ConsentBanner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const LEGAL_PAGES = { '/privacy': 'privacy', '/terms': 'terms', '/refunds': 'refunds' };

function AppContent() {
  const [showWelcome, setShowWelcome] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user has started the program
    const hasStarted = localStorage.getItem('coach_rands_started');
    if (hasStarted) {
      setShowWelcome(false);
    }
    
    // If on program landing and has started, redirect to module1
    if (location.pathname === '/program' && hasStarted) {
      navigate('/module1');
    }
  }, [location.pathname, navigate]);

  const handleStart = () => {
    localStorage.setItem('coach_rands_started', 'true');
    setShowWelcome(false);
    navigate('/module1');
  };

  if (showWelcome && location.pathname === '/program') {
    return <WelcomePage onStart={handleStart} />;
  }

  return (
    <div className="flex min-h-screen bg-mono-base" data-testid="app-container">
      <Sidebar />
      <main className="flex-1 md:ml-64">
        <Routes>
          <Route path="/program" element={<WelcomePage onStart={handleStart} />} />
          <Route path="/module1" element={<ModulePage moduleId="module1" />} />
          <Route path="/module2" element={<ModulePage moduleId="module2" />} />
          <Route path="/module3" element={<ModulePage moduleId="module3" />} />
          <Route path="/module4" element={<ModulePage moduleId="module4" />} />
          <Route path="/module5" element={<ModulePage moduleId="module5" />} />
          <Route path="/module6" element={<ModulePage moduleId="module6" />} />
          <Route path="/reference" element={<ModulePage moduleId="reference" />} />
        </Routes>
      </main>
    </div>
  );
}

function RootSwitch() {
  const location = useLocation();
  if (location.pathname === '/') {
    return <Navigate to="/free" replace />;
  }
  if (LEGAL_PAGES[location.pathname]) {
    return <LegalPage page={LEGAL_PAGES[location.pathname]} />;
  }
  if (location.pathname.startsWith('/free')) {
    return <FreeTier />;
  }
  if (location.pathname.startsWith('/admin')) {
    return <AdminWaitlist />;
  }
  if (location.pathname.startsWith('/calculator')) {
    return <PublicCalculator />;
  }
  return (
    <PaidGate>
      <AppContent />
    </PaidGate>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RootSwitch />
        <ConsentBanner />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
